import { GenericResultModel } from "src/app/interfaces/entities/base";

export interface ProjectGetBoardListResponse extends GenericResultModel {
  boards: ProjectHubBoardListItem[];
}

export interface ProjectGetBoardResponse extends GenericResultModel {
  sparks: ProjectHubSpark[];
  pinnedSparks: ProjectHubSpark[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  unreadSparksCount: number;
}

export interface ProjectHubBoardListItem {
  id: number;
  name: string;
  isDeleted: boolean;
  sparkCount?: number;
  unreadSparksCount?: number;
}

export interface SparkContent {
  text: string;
  files: {
    [key: string]: {
      file?: File;
      fileName: string;
      fileType: string;
      url?: string;
    };
  };
}

export interface ProjectHubSpark {
  id: number | null;
  userEmail: string | null;
  content: SparkContent;
  dateCreated?: Date;
  lastModifiedDate?: Date;
  lastModifiedBy?: string;
  tags?: number[];
  pinned?: boolean;
  isDeleted?: boolean;
  hasImage?: boolean;
  hasAttachments?: boolean;
  answerCount?: number;
  isNew?: boolean;
  liked?: boolean;
  likeCount?: number;
  likedByUsers?: string[];
  reactions?: {
    [key: string]: string[];
  };
}

// Backend API Types
export interface SparkListItem {
  id: number;
  content: string;
  userEmail: string;
  dateCreated: string; // ISO date string
  answerCount: number;
}

export interface SparkAnswerItem {
  id: number;
  content: string;
  userEmail: string;
  dateCreated: string; // ISO date string
  isDeleted: boolean;
  liked?: boolean;
  likeCount?: number;
}

// Request/Response types
export interface GetSparkBoardRequest {
  sparkBoardId: number;
  pageNumber?: number;
  pageSize?: number;
  searchTerm?: string;
}

export interface GetSparkBoardResponse {
  sparks: SparkListItem[];
  pinnedSparks: SparkListItem[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

export interface GetSparkAnswersRequest {
  sparkId: number;
}

export interface GetSparkAnswersResponse {
  answers: SparkAnswerItem[];
}

export interface WriteSparkAnswerRequest {
  sparkId: number;
  answer: {
    id?: number; // Optional for new answers
    content?: string; // Required for new/update, omit for delete
    isDeleted?: boolean; // True for delete operation
  };
}

export interface WriteSparkRequestModel {
  boardId: number;
  spark: {
    id: number | null;
    userEmail: string | null;
    content: {
      text: string;
      files: { [key: string]: { fileName: string; fileType: string } };
    };
    dateCreated?: Date;
    tags?: number[];
    pinned?: boolean;
    isDeleted?: boolean;
  };
}

export interface GetSparkRequest {
  sparkId: number;
}

export interface GetSparkResponse extends GenericResultModel {
  spark: {
    id: number;
    userEmail: string;
    content: {
      text: string;
      files: { [key: string]: { fileName: string; fileType: string } };
    };
    dateCreated: string;
    tags?: string[];
    pinned?: boolean;
    isDeleted?: boolean;
  };
}

export interface tagColor {
  background: string;
  text: string;
  border: string;
}

export const tagColors: tagColor[] = [
  {
    background: "#9DCEE7",
    text: "#085881",
    border: "#085881",
  },
  {
    background: "#B8E6B8",
    text: "#2E7D32",
    border: "#2E7D32",
  },
  {
    background: "#FFD4B3",
    text: "#E65100",
    border: "#E65100",
  },
  {
    background: "#E1BEE7",
    text: "#6A1B9A",
    border: "#6A1B9A",
  },
  {
    background: "#FFCDD2",
    text: "#C62828",
    border: "#C62828",
  },
  {
    background: "#B2DFDB",
    text: "#00695C",
    border: "#00695C",
  },
  {
    background: "#C5CAE9",
    text: "#303F9F",
    border: "#303F9F",
  },
  {
    background: "#FFECB3",
    text: "#FF8F00",
    border: "#FF8F00",
  },
];

// Spark interaction types
export interface MarkSparkAsReadRequest {
  sparkId: number;
}

export interface MarkAllSparksAsReadRequest {
  boardId: number;
}

export interface LikeSparkRequest {
  sparkId: number;
  isLiked: boolean;
}

export interface LikeAnswerRequest {
  answerId: number;
  isLiked: boolean;
}

export interface ReactToSparkRequest {
  sparkId: number;
  reaction: string;
  isAdding: boolean;
}

export interface SparkBoardFilterState {
  period: { from: Date | null; to: Date | null };
  tags: number[];
  person: string | null;
  unread: boolean;
}
